module.exports = __webpack_public_path__ + "static/media/pexels-liza-summer.0028e052.png";